/* tslint:disable */
/* eslint-disable */
/**
 * My REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: jason.tai@octopus-tech.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BorrowDto,
    BorrowDtoFromJSON,
    BorrowDtoFromJSONTyped,
    BorrowDtoToJSON,
} from './BorrowDto';
import {
    Pageable,
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
} from './Pageable';
import {
    Sort,
    SortFromJSON,
    SortFromJSONTyped,
    SortToJSON,
} from './Sort';

/**
 * 
 * @export
 * @interface PageBorrowDto
 */
export interface PageBorrowDto {
    /**
     * 
     * @type {Array<BorrowDto>}
     * @memberof PageBorrowDto
     */
    content?: Array<BorrowDto>;
    /**
     * 
     * @type {boolean}
     * @memberof PageBorrowDto
     */
    empty?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageBorrowDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageBorrowDto
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageBorrowDto
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof PageBorrowDto
     */
    numberOfElements?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof PageBorrowDto
     */
    pageable?: Pageable;
    /**
     * 
     * @type {number}
     * @memberof PageBorrowDto
     */
    size?: number;
    /**
     * 
     * @type {Sort}
     * @memberof PageBorrowDto
     */
    sort?: Sort;
    /**
     * 
     * @type {number}
     * @memberof PageBorrowDto
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof PageBorrowDto
     */
    totalPages?: number;
}

export function PageBorrowDtoFromJSON(json: any): PageBorrowDto {
    return PageBorrowDtoFromJSONTyped(json, false);
}

export function PageBorrowDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageBorrowDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': !exists(json, 'content') ? undefined : ((json['content'] as Array<any>).map(BorrowDtoFromJSON)),
        'empty': !exists(json, 'empty') ? undefined : json['empty'],
        'first': !exists(json, 'first') ? undefined : json['first'],
        'last': !exists(json, 'last') ? undefined : json['last'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'pageable': !exists(json, 'pageable') ? undefined : PageableFromJSON(json['pageable']),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'sort': !exists(json, 'sort') ? undefined : SortFromJSON(json['sort']),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
    };
}

export function PageBorrowDtoToJSON(value?: PageBorrowDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content === undefined ? undefined : ((value.content as Array<any>).map(BorrowDtoToJSON)),
        'empty': value.empty,
        'first': value.first,
        'last': value.last,
        'number': value.number,
        'numberOfElements': value.numberOfElements,
        'pageable': PageableToJSON(value.pageable),
        'size': value.size,
        'sort': SortToJSON(value.sort),
        'totalElements': value.totalElements,
        'totalPages': value.totalPages,
    };
}

